/**
 * List of mortgage campaigns, each {value} (not key!) maps to a folder /common/module/mortgage/campaign/{value}
 */
export const enum MortgageCampaignEnum {
  /**
   * Mortgage Finder calculator
   */
  mfCalculator = 'mfcalculator',

  /**
   * Mortgage Finder pre-approved simple link
   */
  mfPreApproved = 'mfpreapproved',

  /**
   * Mortgage Finder pre-approved link with mortgage details preview
   */
  mfPreApproved2 = 'mfpreapproved2',

  /**
   * Mortgage Finder pre-approved link with mortgage details preview (different layout)
   */
  mfPreApproved3 = 'mfpreapproved3',

  /**
   * Mortgage Finder pre-approved link with mortgage details preview (different layout)
   */
  mfPreApproved4 = 'mfpreapproved4',

  /**
   * Mortgage Finder pre-approved link with per month cost (show in facts table)
   */
  mfestimated = 'mfestimated',

  /**
   * Mortgage Finder pre-approved link with per month cost (show in facts table)
   */
  mfestimated2 = 'mfestimated2',

  /**
   * Mortgage Finder pre-approved link with per month cost (show in new PLP page)
   */
  mfestimated3 = 'mfestimated3',

  /**
   * BMCE BANK pre-approved simple link
   */
  bmcePreApproved = 'bmcepreapproved',

  /**
   * Sarouty credit simulator simple link
   */
  saroutyCreditSimulator = 'saroutycreditsimulator',

  /**
   * Bank Audi calculator
   */
  bankaudiCalculator = 'bankaudicalculator',

  /**
   * SHL calculator
   */
  shlCalculator = 'shlcalculator',

  /**
   * SHL pre-approved link with mortgage details preview
   */
  shlPreapproved = 'shlpreapproved',

  /**
   * Bidaya calculator
   */
  bidayaCalculator = 'bidayacalculator',

  /**
   * Bidaya pre-approved link with mortgage details preview
   */
  bidayaPreapproved = 'bidayapreapproved',

  /**
   * Romooz calculator
   */
  rzsaudicalculator = 'rzsaudicalculator',

  /**
   * Nbb calculator
   */
  nbbbahraincalculator = 'nbbbahraincalculator',
}
